(function () {
  const autofitText = () => {
    const vminSize =
      (67 * Math.min(window.innerWidth, window.innerHeight)) / 100;
    const maxFontSize = Math.min(vminSize, 550);
    document.querySelectorAll(".hero-text").forEach((el) => {
      const originalStyles = {
        whiteSpace: el.style.whiteSpace,
        display: el.style.display,
      };
      el.style.whiteSpace = "nowrap";
      el.style.display = "inline-block";
      el.style.setProperty("--autoFontSize", el.parentElement.offsetWidth / 2);
      const computedStyle = getComputedStyle(el);
      const visibleWidth = parseFloat(computedStyle.width);
      const visibleHeight = parseFloat(computedStyle.height);
      const widthRatio = visibleWidth / el.scrollWidth;
      const heightRatio = visibleHeight / el.scrollHeight;
      const fixRatio = Math.min(widthRatio, heightRatio);
      let desiredFontSize = (el.parentElement.offsetWidth * fixRatio) / 2;
      desiredFontSize = Math.min(desiredFontSize, maxFontSize);
      el.style.setProperty("--autoFontSize", desiredFontSize);
      const finalWidth = el.scrollWidth;
      const finalHeight = el.scrollHeight;
      if (finalWidth > visibleWidth || finalHeight > visibleHeight) {
        const safetyRatio = Math.min(
          visibleWidth / finalWidth,
          visibleHeight / finalHeight
        );
        const safeFontSize = desiredFontSize * safetyRatio * 0.95;
        el.style.setProperty(
          "--autoFontSize",
          Math.min(safeFontSize, maxFontSize)
        );
      }
      el.style.whiteSpace = originalStyles.whiteSpace;
      el.style.display = originalStyles.display;
      autofitContainers.add(el.parentElement);
    });
  };
  const [onloadOld, onresizeOld, autofitContainers] = [
    window.onload,
    window.onresize,
    new Set(),
  ];
  window.onresize = () => {
    if (onresizeOld) onresizeOld();
    autofitText();
  };
  window.onload = () => {
    if (onloadOld) onloadOld();
    autofitText();
    autofitContainers.forEach((c) =>
      new MutationObserver((ms) => {
        autofitText();
      }).observe(c, {
        attributes: true,
        attributeFilter: ["style"],
      })
    );
  };
  autofitText();
  document.addEventListener("shopify:section:load", function () {
    autofitText();
  });
})();
